<template>
  <div>
    <h2 class="text-h6">Email Preview</h2>
    <h3 class="h4 subtitle mb-4 text-muted">
      This is a preview of what will be emailed to you customer. Please note that different email clients, such as
      Outlook & Apple Mail, may display email messages differently, so it's best to send some test emails to confirm
      they look consistent across different devices.
    </h3>
    <c-button
      v-if="!isRequesting"
      color="primary"
      class="refresh-site"
      :class="{ 'is-loading': isRequesting }"
      @click="get"
    >
      <span class="icon"><i class="fa fa-refresh" /></span>
      <span>Refresh</span>
    </c-button>
    <div class="email-preview message-box">
      <div class="message">
        <div v-if="!isRequesting" class="message-body" v-html="emailPreview" />
        <div v-if="isRequesting" class="message-body"><p class="text-h6 is-4">Generating email preview...</p></div>
      </div>
    </div>
  </div>
</template>

<script>
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  components: {},

  props: {
    client: Object,
  },

  data() {
    return {
      error: null,
      isRequesting: false,
      emailPreview: null,
    };
  },

  created() {
    this.get();
  },

  methods: {
    get() {
      if (!this.client) {
        this.error = 'Error getting email preview';
        return;
      }
      const data = {
        id: this.client._id,
      };
      this.isRequesting = true;
      this.$http
        .post(buildEndpoint('clients/email/view-preview'), data)
        .then((response) => {
          this.isRequesting = false;
          if (response.data.success) {
            this.emailPreview = response.data.data;
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error getting email preview',
              message: response.data.error,
            });
          }
        })
        .catch((error) => {
          this.isRequesting = false;
          this.$store.commit('addErrorMessage', {
            header: 'Error getting email preview',
            message: error,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped="">
.email-preview {
  margin: 30px 0;
  .message {
    background-color: white !important;
    color: black;
    .message-body {
      max-height: 250px;
      overflow-x: scroll;
      overflow-y: auto;
    }
  }
}
</style>
